export default __webpack_public_path__ + "static/media/SoBCurriculum.7bc46b88.pdf";